export default "__VITE_ASSET__BMbwd$C2__"